import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { AddAPIKeyForm } from '../../../components';
import { Title } from '../../styles';

const CreateAPIKey = () => {
  return (
    <>
      <Row justify="center" style={{ paddingTop: '28px' }}>
        <Col lg={12} md={14} sm={24} style={{ padding: '20px 30px' }}>
          <Title data-testid="create-apikey-title">
            <FormattedMessage id="ApiKeys.form.title" />
          </Title>

          <AddAPIKeyForm />
        </Col>
      </Row>
    </>
  );
};

export default CreateAPIKey;
